"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuthenticationState = exports.isSuspendedResponse = void 0;
var token_1 = require("./token");
var authenticate_1 = require("./authenticate");
var authorize_1 = require("./authorize");
var session_tasks_1 = require("./session-tasks");
/**
 * Foundry has a specific error response when a user of a suspended organization attempts
 * to request data
 *
 * @param {*} response
 */
function isSuspendedResponse(response) {
    var _a;
    return (response === null || response === void 0 ? void 0 : response.status) === 403 && ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.status) === 1303;
}
exports.isSuspendedResponse = isSuspendedResponse;
var SuspendedOrganizationError = /** @class */ (function (_super) {
    __extends(SuspendedOrganizationError, _super);
    function SuspendedOrganizationError() {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        var _this = _super.apply(this, params) || this;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, SuspendedOrganizationError);
        }
        _this.name = "SuspendedOrganizationError";
        return _this;
    }
    return SuspendedOrganizationError;
}(Error));
function combineWardenEntityWithFoundryData(entity) {
    return __awaiter(this, void 0, void 0, function () {
        var error_1, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, session_tasks_1.setupUserSession(entity)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    response = error_1.response ? error_1.response : error_1;
                    if (response.status) {
                        if (isSuspendedResponse(response)) {
                            throw new SuspendedOrganizationError();
                        }
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function getAuthenticationState(shortLivedToken) {
    return __awaiter(this, void 0, void 0, function () {
        var longLivedToken, _a, token, entity, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, , 5]);
                    longLivedToken = token_1.getToken();
                    return [4 /*yield*/, authenticate_1.authenticate(longLivedToken, shortLivedToken)];
                case 1:
                    _a = _b.sent(), token = _a.token, entity = _a.entity;
                    return [4 /*yield*/, authorize_1.authorize(entity, ["general_access"])];
                case 2:
                    _b.sent();
                    token_1.setToken(token);
                    return [4 /*yield*/, combineWardenEntityWithFoundryData(entity)];
                case 3:
                    _b.sent();
                    return [2 /*return*/, "ready"];
                case 4:
                    error_2 = _b.sent();
                    if ((error_2 === null || error_2 === void 0 ? void 0 : error_2.name) === "UnauthenticatedError" || error_2 instanceof authenticate_1.UnauthenticatedError) {
                        token_1.removeToken();
                        session_tasks_1.closeUserSession();
                        return [2 /*return*/, "login"];
                    }
                    if ((error_2 === null || error_2 === void 0 ? void 0 : error_2.name) === "UnauthorizedError" || error_2 instanceof authorize_1.UnauthorizedError) {
                        return [2 /*return*/, "unauthorized"];
                    }
                    if ((error_2 === null || error_2 === void 0 ? void 0 : error_2.name) === "SuspendedOrganizationError" || error_2 instanceof SuspendedOrganizationError) {
                        return [2 /*return*/, "suspended"];
                    }
                    throw error_2;
                case 5: return [2 /*return*/];
            }
        });
    });
}
exports.getAuthenticationState = getAuthenticationState;
